import { render, staticRenderFns } from "./MedicineDetail.vue?vue&type=template&id=55ac3018&scoped=true"
import script from "./MedicineDetail.vue?vue&type=script&lang=js"
export * from "./MedicineDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicineDetail.vue?vue&type=style&index=0&id=55ac3018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac3018",
  null
  
)

export default component.exports